import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    function isJSON(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    return async (payload) => {
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        //? This is for helping debug the webview token issues for the mobile app
        //? for debug: console.log('🗃 tokenCookie', getCookieByName(appCookieKey));
        //? for debug: console.log('🗃 AuthToken', getCookieByName(sharedCookieKey));

        const jwtFromCookie = getCookieByName(appCookieKey);

        const strCookie = getCookieByName(sharedCookieKey);
        let spatFromCookie = null;

        if (isJSON(strCookie)) {
            const wholeTokenFromCookie = JSON.parse(strCookie);
            spatFromCookie = wholeTokenFromCookie.spat;
        }

        let result = await apiClient(config).apiMethod({
            method: 'GetPlayerData',
            headers: {
                'X-Auth-Token': jwtFromCookie,
                'X-Auth-Spat': spatFromCookie,
            },
            args: {
                ...payload,
            },
        });
        return {
            ...result,
            loggedIn: result.player != null ? true : false,
        };
    };
};

////////// Example of expected return ///////////
// {
//     "player": {
//         "id": 1283,
//         "registrar_id": "CA0B0CFA-F8B2-46D8-A3E9-2A1FFF390504",
//         "account_type": "registered",
//         "registered_on": 1634097600,
//         "firstname": "Alan",
//         "lastname": "Davis",
//         "email": "alan.davis1@scientificgames.com",
//         "phone": "770-222-3333",
//         "birthdate": null,
//         "address": {
//             "state": "PA",
//             "address1": "123 Dev street",
//             "address2": null,
//             "city": "Smith Township",
//             "zip": "15004"
//         },
//         "extra": {
//             "gender": "M"
//         },
//         "alt_addresses": null,
//         "actions": ["verify-account"]
//     },
//     "session": {
//         "handle": "67020e3f-b6a6-4886-81ee-3856ec69b0bb",
//         "login_type": "desktop",
//         "login_at": 1637249183
//     },
//     "spat": "{\"player\":{\"registrar_id\":\"CA0B0CFA-F8B2-46D8-A3E9-2A1FFF390504\",\"registered_on\":1634097600,\"firstname\":\"Alan\",\"lastname\":\"Davis\",\"email\":\"alan.davis1@scientificgames.com\",\"phone\":\"770-561-5275\",\"account_type\":\"registered\",\"birthdate\":null,\"actions\":[\"verify-account\"],\"address\":{\"state\":\"PA\",\"address1\":\"123 Dev street\",\"address2\":null,\"city\":\"Smith Township\",\"zip\":\"15004\"}},\"smt\":1637269449,\"signature\":\"6fef48bba710d925fec1f6f1daa6723951430851f0dae91f585f4cb297be7baa\"}",
//     "token": "eyJpdiI6IlVzV0YwV1IraG80cFdnaWhzaHR5b2c9PSIsInZhbHVlIjoiXC9qcXhzQjZockFcL1hvZzJieGFDTGFNTGZVOTJTZDZmYjVnWVVud21RUnhWMks5dVJMYm9XeDZ1V3pCQUNJRnJ3TEF4NGlaKzgwVnV6VXJDRHN4b0N1MHZsNklCVXNSbnZnUkpnbzBNRDZPbmVWODZMREtCajBTRDV5bkVRak15ekFiNGRPenFxVytWWU1tZmJQUWRoQWc9PSIsIm1hYyI6IjY1MmVkNzA3NmNmYTVhZmJjZGFlZDNkZmJjNzQxZTRiMzQzOWNiM2IxNGM4ZjgzNGVkN2UxZDczMjJiYTIzYzMifQ=="
// }
